import { render } from "./RoutingKeyTable.vue?vue&type=template&id=a36db778&ts=true"
import script from "./RoutingKeyTable.vue?vue&type=script&lang=ts"
export * from "./RoutingKeyTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__